import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dnsFilter = defineConnector({
  identifier: "dnsFilter",
  name: "DNSFilter",
  tagLine: "Protective DNS and threat blocking",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api.dnsfilter.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a token in DNSFilter",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://dnsfilter.stoplight.io/docs/dnsfilter-api/](https://dnsfilter.stoplight.io/docs/dnsfilter-api/) to create a token for the DNSFilter API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.dnsfilter.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.dnsfilter.com/")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
